import { BASE_URL, CORPORATE } from "constants/api";
import axios from "../helpers/axiosInstance";
import { HeadCell } from "models/app";
import { ICorporate, ICorporateInput } from "models/corporate";


export async function getCorporates(params: string = ""): Promise<ICorporate[]> {
  const response = await axios.get(BASE_URL + CORPORATE + params);
  return response.data;
}
export async function addCorporate(data: ICorporateInput) {
  const response = await axios.post(BASE_URL + CORPORATE, data);
  return response.data;
}
export async function editCorporate(data: ICorporateInput, id: string) {
  const response = await axios.patch(BASE_URL + CORPORATE + "/" + id, data);
  return response.data;
}

export async function deleteCorporate(id: string) {
  
  const response = await axios.delete(BASE_URL + CORPORATE + "/" + id);
  return response.data;
}

export const corporateCells: HeadCell[] = [   
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "T_name",
  },
  {
    id: "companies",
    numeric: false,
    disablePadding: false,
    label: "T_companies",
  },
  {
    id: "users",
    numeric: false,
    disablePadding: false,
    label: "T_users",
  },
  {
    id: "actions",
    numeric: false,
    disablePadding: false,
    label: "T_action",
  },
];
